/* eslint-disable  */
import axios from 'axios';
import Vue from 'vue';
import { checkError, checkSuccess } from '../../../services/httpMessage';

// HTPP
let http = axios.create({
  baseURL: Vue.prototype.$anoreg.arquivos.urlApi,
  timeout: 0,
  headers: {
    // 'X-Custom-Header': 'foobar',
  },
});

http.interceptors.request.use(request => {
  const token = localStorage.getItem('token');
  request.headers.authorization = `Bearer ${token}`;
  return request;
});

http.interceptors.response.use(
  function (response) {
    checkSuccess(response.data);
    return response;
  },
  function (error) {
    return checkError(error);
  },
);

export default http;
